import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBooleanGroupSubstract: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"boolean-group-substract"} maskId="square-filled-radius-0-stroke-1-IconBooleanGroupSubstract"><path fillRule="evenodd" clipRule="evenodd" d="M8 2V8H2V22H16V16H22V2H8ZM21 15V3H9V15H21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBooleanGroupSubstract;
